module.exports = __webpack_public_path__ + "img/sliders-03.8cbd9d67.jpg";